import styled from 'styled-components';

export const NewTrustStripSection = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 16px 0 16px;
  padding: 10px 0;
  cursor: pointer;

  @media (max-width: 720px) {
    margin: 12px 0 14px;
    padding: 10px 0;
    cursor: default;
  }

  .returnRefund {
    flex-basis: 32%;
    text-align: center;
    position: relative;
    padding: 0 6px;

    &:after {
      content: '';
      position: absolute;
      width: 0.5px;
      height: 30px;
      right: 0;
      top: 50%;
      transform: translate(0, -50%);
      background: #bbbbbb7a;
    }

    &:nth-child(3) {
      &:after {
        width: 0;
      }
    }

    img,
    svg {
      width: clamp(30px, 3vw, 32px);
      height: clamp(30px, 3vw, 32px);
    }

    p {
      font-size: clamp(10px, 2vw, 12px);
      font-weight: 500;
      color: hsl(0deg, 0%, 0%, 60%);
      width: 100px;
      margin: auto;

      @media (max-width: 720px) {
        width: 100%;
        padding: 0 16px;
      }
    }
  }
`;

export const NewTrustPopup = styled.div`
  text-align: left;
  padding: 16px;

  @media (max-width: 720px) {
    max-height: 500px;
    overflow-y: auto;
  }
`;

export const PopupDataList = styled.div`
  padding: 10px 0;

  h2 {
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 6px;
    color: hsl(0deg, 0%, 0%, 82%);
  }

  p,
  a {
    font-size: 14px;
    color: hsl(0deg, 0%, 0%, 87%);
  }
`;

export const ReadCondition = styled.div`
  text-transform: uppercase;
  color: #63b0a8;
  font-size: 14px;
  letter-spacing: 0.29px;
  padding-top: 10px;
  font-weight: 500;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;
